// extracted by mini-css-extract-plugin
module.exports = {"SShowsContainer":"Shows_SShowsContainer__6BttC","STicketButton":"Shows_STicketButton__dHuxT","odd":"Shows_odd__n52PL","SKinoklubbTicket":"Shows_SKinoklubbTicket__1g4NK"};